import { Link } from 'react-router-dom';
import { paths } from '@/routes/paths';
import type { RecentList } from './types';

interface ResearchHomeRecentListsProps {
  lists: RecentList[];
  loading: boolean;
  errored: boolean;
}

export default function ResearchHomeRecentLists({
  lists,
  loading,
  errored,
}: ResearchHomeRecentListsProps) {
  return (
    <section className="rh-panel rh-recent" aria-labelledby="rh-recent-heading">
      <div className="rh-panel-head">
        <div className="rh-panel-title">
          <i className="bi bi-clock" aria-hidden="true" />
          <h2 id="rh-recent-heading">Recent lists</h2>
        </div>
        <Link to={paths.previousResults} className="rh-view-all">
          View all <i className="bi bi-chevron-right" aria-hidden="true" />
        </Link>
      </div>
      <div className="rh-panel-body rh-panel-body--table">
        {loading ? (
          <div className="rh-skel-stack">
            {[0, 1, 2, 3].map((i) => (
              <span key={i} className="rh-skeleton rh-skeleton--row" />
            ))}
          </div>
        ) : errored ? (
          <p className="rh-empty">Couldn&apos;t load your lists right now. Try again shortly.</p>
        ) : lists.length === 0 ? (
          <div className="rh-empty-block">
            <p className="rh-empty">No lists yet.</p>
            <Link to={paths.targetList} className="rh-link-btn">
              Build your first list
            </Link>
          </div>
        ) : (
          <div className="rh-table-wrap">
            <table className="rh-table">
              <thead>
                <tr>
                  <th scope="col">List name</th>
                  <th scope="col">Type</th>
                  <th scope="col">Modified</th>
                  <th scope="col">Companies</th>
                </tr>
              </thead>
              <tbody>
                {lists.map((r) => (
                  <tr key={r.id}>
                    <td data-label="List name">
                      <Link to={r.href} className="rh-table-name">
                        {r.name}
                      </Link>
                    </td>
                    <td data-label="Type">
                      <span
                        className={`rh-badge ${r.kind === 'buyer' ? 'rh-badge--buyer' : 'rh-badge--target'}`}
                      >
                        {r.typeLabel}
                      </span>
                    </td>
                    <td data-label="Modified" className="rh-table-modified">
                      {r.modified}
                    </td>
                    <td data-label="Companies" className="rh-table-count">
                      {r.count}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </section>
  );
}
